import { render, staticRenderFns } from "./AddSupplierStockTemplateComponent.vue?vue&type=template&id=28f1ef04&"
import script from "./AddSupplierStockTemplateComponent.vue?vue&type=script&lang=js&"
export * from "./AddSupplierStockTemplateComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports